import type {
  AESDataEntityLRTRentalStockTrans,
  CustomersV3,
  LRTInventEquipmentGlobalsV3,
  LRTInventEquipmentsV4,
  MiraElement,
  SalesOrderHeadersV3
} from '@shared/types/mira';

export type MiraLookupSource = 'product' | 'customer';

type ProductMiraElement = LRTInventEquipmentsV4 &
  AESDataEntityLRTRentalStockTrans &
  LRTInventEquipmentGlobalsV3 &
  SalesOrderHeadersV3;

type ProductMiraField = keyof ProductMiraElement;
type CustomerMiraField = keyof CustomersV3;

const PRODUCT_MIRA_FIELD_NAMES: ProductMiraField[] = [
  'InventEquipmentId',
  'LRTInventSerialName',
  'Description',
  'ItemId',
  'LRTInventSerialAssetId',
  'LogisticStatusId',
  'LRTAcquisitionDate',
  'AESRentalHydraulicOilTypeId',
  'ManufactureInventSerialId',
  'ProdDate',
  'RefIdReceipt',
  'SalesOrderName',
  'FormattedDelveryAddress',
  'ResponsibleInventSiteId',
  'RedeliveryDateTime'
];

const CUSTOMER_MIRA_FIELD_NAMES: CustomerMiraField[] = [
  'CustomerAccount',
  'OrganizationName',
  'LRTRentalPriceGroupId',
  'CustClassificationId'
];

const PRODUCT_MIRA_FIELDS: ReadonlySet<keyof MiraElement> = new Set(
  PRODUCT_MIRA_FIELD_NAMES
);
const CUSTOMER_MIRA_FIELDS: ReadonlySet<keyof MiraElement> = new Set(
  CUSTOMER_MIRA_FIELD_NAMES
);

export const isMiraFieldForLookupSource = (
  miraName: keyof MiraElement | undefined,
  source: MiraLookupSource
) => {
  if (!miraName) {
    return false;
  }

  return source === 'product'
    ? PRODUCT_MIRA_FIELDS.has(miraName)
    : CUSTOMER_MIRA_FIELDS.has(miraName);
};
